import { useMutation } from '@apollo/client'
import { mockExamsPlatformClient } from 'apollo-client'
export const useMockExamsPlatformMutation =
  (mutation, options) => useMutation(mutation, { ...options, client: mockExamsPlatformClient })
